import React from 'react';
import ContentPageLayout from 'UI/components/templates/ContentPageLayout';

import { Header } from './components';
import { MainLayoutContainer } from './Layout.styled';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.path
 * @param {string|React.ReactNode} props.title
 * @param {React.ReactNode} [props.children]
 * @param {React.ReactNode} [props.subtitle]
 * @param {React.ReactNode} [props.extraActions]
 * @param {boolean} [props.isBackNavigationEnabled]
 * @param {boolean} [props.isLoading]
 * @param {Function} [props.onRefresh]
 */
export const Layout = ({
  path,
  title,
  subtitle,
  extraActions,
  isBackNavigationEnabled = false,
  isLoading = false,
  children,
  onRefresh
}) => {
  return (
    <ContentPageLayout mode="customLayout">
      <MainLayoutContainer>
        <Header
          isBackNavigationEnabled={isBackNavigationEnabled}
          isLoading={isLoading}
          path={path}
          title={title}
          subtitle={subtitle}
          extraActions={extraActions}
          onRefresh={onRefresh}
        />
        {children}
      </MainLayoutContainer>
    </ContentPageLayout>
  );
};
